import React, { CSSProperties } from "react";
import clsx from "clsx";
import { HvAvatar } from "@hitachivantara/uikit-react-core";
import OverflowTooltip from "../OverflowTooltip";
import useStyles from "./styles";

interface LevelBadgeProps {
  name?: string;
  color: string;
  textIcon: string;
  absolutePosition?: boolean;
  style?: CSSProperties;
  className?: string;
}

const LevelBadge: React.FC<LevelBadgeProps> = ({
  name,
  color,
  textIcon,
  absolutePosition = false,
  style,
  className,
}) => {
  const classes = useStyles();

  return (
    <span
      style={style}
      className={clsx(
        classes.root,
        {
          [classes.absolute]: absolutePosition,
        },
        className
      )}
    >
      <HvAvatar
        className={classes.badge}
        backgroundColor="transparent"
        color={color}
        variant="circular"
        containerProps={{}}
        size="XS"
      >
        {textIcon}
      </HvAvatar>
      {name && <OverflowTooltip className={classes.label} data={name} />}
    </span>
  );
};

export default React.memo(LevelBadge);
